import React from "react";
import { useSelector } from 'react-redux';
import { isEmpty } from "lodash";

const Header = () =>
{
  const { productUrls, uiTheme } = useSelector((state) => state.activation);
  return (
    <div className="template-section">
        <div className="template-header-container">
          <div className="header" style={{backgroundColor : uiTheme.bannerColour}}>
            {!isEmpty(productUrls.logo) && <img
              src={productUrls.logo}
              alt="Product header logo"
              className="header-logo"
            />}
          </div>
        </div>
      </div>
  );
};

export default Header;
